import * as constActions from './const';
import initialState from './initialState';
import eProfileView from '../components/TabContent/Profiles/Models/Enums/eProfileView';
import eS3DataType from '../components/TabContent/Advanced/Models/Enums/eS3DataType';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_EDIT_PERMISSION_SUCCESS:
      return Object.assign({}, state, {
        hasEditSettingsPermissions: action.hasEditSettingsPermissions
      });
    case constActions.GET_SCAN_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        scanGroups: action.scanGroups
      });
    case constActions.DELETE_GROUP_SUCCESS:
      return Object.assign({}, state, {
        scanGroups: state.scanGroups.filter(currGroup => currGroup.GroupId !== action.groupId)
      });
    case constActions.ADD_GROUP_SUCCESS:
      return Object.assign({}, state, {
        scanGroups: [...state.scanGroups, Object.assign({}, action.scanGroup, { GroupId: action.groupId })]
      });
    case constActions.GET_SCAN_ACCOUNTS_SUCCESS:
      return Object.assign({}, state, {
        scanAccounts: action.scanAccounts
      });
    // case constActions.DELETE_ACCOUNT_SUCCESS:
    //     return Object.assign({}, state, {
    //         scanAccounts: state.scanAccounts.filter((currAccount) => currAccount !== action.accountName),
    //     });
    case constActions.ADD_ACCOUNT_SUCCESS:
      return Object.assign({}, state, {
        scanAccounts: [...state.scanAccounts, action.accountName]
      });
    case constActions.GET_GROUP_INFORMATION_SUCCESS:
      return Object.assign({}, state, {
        groupInformation: action.groupInformation
      });
    case constActions.GET_SCAN_POPULATION_SUCCESS:
      return Object.assign({}, state, {
        scanPopulation: action.scanPopulation
      });
    case constActions.GET_GROUP_SCHEDULING_SUCCESS:
      return Object.assign({}, state, {
        groupScheduling: action.groupScheduling
      });

    //SCAN POPULCATION
    case constActions.DELETE_SCAN_POPULATION_SUCCESS:
    case constActions.ADD_SCAN_POPULATION_SUCCESS:
      return Object.assign({}, state, {
        scanPopulation: action.scanPopulation
      });
    case constActions.SYNC_AD_SUCCESS:
      return Object.assign({}, state, {
        adSyncResult: action.adSyncResult
      });

    //GROUP SCHEDULING
    case constActions.DELETE_GROUP_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        groupScheduling: state.groupScheduling.filter(curVal => action.groupSchedulingIds.indexOf(curVal.id) == -1)
      });
    case constActions.UPDATE_GROUP_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        groupScheduling: state.groupScheduling.map((curVal, index) => {
          if (curVal.id == action.groupScheduling.id) {
            return action.groupScheduling;
          }
          return curVal;
        })
      });
    case constActions.ADD_GROUP_SCHEDULE_SUCCESS:
      return Object.assign({}, state, {
        groupScheduling: [...state.groupScheduling, action.groupScheduling]
      });
    case constActions.UPDATE_ADVANCED_SETTINGS:
      return Object.assign({}, state, {
        [action.fieldName]: action.settings
      });
    case constActions.GET_ALL_WEB_PROXY_SETTINGS:
      return Object.assign({}, state, {
        webProxies: action.results
      });
    case constActions.CREATE_WEB_PROXY:
      return Object.assign({}, state, {
        webProxies: [...state.webProxies, action.proxyDetails]
      });
    case constActions.UPDATE_WEB_PROXY:
      return Object.assign({}, state, {
        webProxies: state.webProxies.map(r => {
          if (r.Id == action.proxyDetails.Id) {
            return action.proxyDetails;
          }
          return r;
        })
      });
    case constActions.DELETE_WEB_PROXY:
      return Object.assign({}, state, {
        webProxies: state.webProxies.filter(r => r.Id != action.proxyId)
      });
    case constActions.UPDATE_SETTINGS:
      return Object.assign({}, state, {
        [action.fieldName]: action.settings
      });

    case constActions.UPDATE_ERORR_FIELD:
      return Object.assign({}, state, {
        advancedErrrors: Object.assign({}, state.advancedErrrors, {
          [action.fieldName]: action.errorText
        })
      });
    //configuration - excluded ip ranges
    case constActions.UPDATE_EXCLUDED_IPS_LIST_SUCCESS:
      return Object.assign({}, state, {
        excludedIpRanges: action.excludedIpRanges
      });
    //////////////////////////////////
    case constActions.GET_ALL_SYSLOG_SETTINGS:
      return Object.assign({}, state, {
        syslogSettings: action.results
      });
    case constActions.DELETE_SYSLOG_SETTINGS:
      return Object.assign({}, state, {
        syslogSettings: action.results
      });
    case constActions.ADD_SYSLOG_SETTINGS:
      return Object.assign({}, state, {
        syslogSettings: action.results
      });

    //configuration - proxy parsers
    case constActions.GET_PROXY_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        proxyParsers: action.proxyParsers,
        selectedProxyParser: action.proxyParsers.length > 0 ? action.proxyParsers[0].proxy_name : ''
      });
    case constActions.ADD_PROXY_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        proxyParsers: [...state.proxyParsers, action.proxyParser],
        selectedProxyParser: action.proxyParser.proxy_name
      });
    case constActions.DELETE_PROXY_PARSERS_SUCCESS: {
      let newParsers = state.proxyParsers.filter(curVal => curVal.proxy_name != action.parserName);
      return Object.assign({}, state, {
        proxyParsers: newParsers,
        selectedProxyParser: newParsers.length > 0 ? newParsers[0].proxy_name : ''
      });
    }
    case constActions.UPDATE_PROXY_PARSERS_SUCCESS: {
      let newParsersUpdate = state.proxyParsers.map((curVal, index) => {
        if (curVal.db_id == action.proxyParser.db_id) {
          return action.proxyParser;
        }
        return curVal;
      });

      return Object.assign({}, state, {
        proxyParsers: newParsersUpdate,
        selectedProxyParser: action.proxyParser.proxy_name
      });
    }
    case constActions.VALIDATE_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        validationLineResult: action.results
      });

    //configuration - proxy parsers folder
    case constActions.GET_PROXY_FOLDERS_SUCCESS:
      return Object.assign({}, state, {
        proxyParsersFolders: action.proxyParsersFolders,
        selectedProxyFolder: action.proxyParsersFolders.length > 0 ? action.proxyParsersFolders[0].directory_path : ''
      });
    case constActions.ADD_PROXY_FOLDER_SUCCESS:
      return Object.assign({}, state, {
        proxyParsersFolders: [...state.proxyParsersFolders, action.proxyParserFolder],
        selectedProxyFolder: action.proxyParserFolder.directory_path
      });
    case constActions.DELETE_PROXY_FOLDER_SUCCESS: {
      let newFolders = state.proxyParsersFolders.filter(curVal => curVal.directory_path != action.folderName);
      return Object.assign({}, state, {
        proxyParsersFolders: newFolders,
        selectedProxyFolder: newFolders.length > 0 ? newFolders[0].directory_path : ''
      });
    }
    case constActions.EDIT_PROXY_FOLDER_SUCCESS:
      return Object.assign({}, state, {
        proxyParsersFolders: state.proxyParsersFolders.map((curVal, index) => {
          if (curVal.directory_path == action.proxyParserFolder.directory_path) {
            return action.proxyParserFolder;
          }
          return curVal;
        })
      });

    //configuration - vpn parsers
    case constActions.GET_VPN_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        vpnParsers: action.vpnParsers,
        selectedVpnParser: action.vpnParsers.length > 0 ? action.vpnParsers[0].parser_name : ''
      });
    case constActions.ADD_VPN_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        vpnParsers: [...state.vpnParsers, action.vpnParser],
        selectedVpnParser: action.vpnParser.parser_name
      });
    case constActions.DELETE_VPN_PARSERS_SUCCESS: {
      let newVpnParsers = state.vpnParsers.filter(curVal => curVal.parser_name != action.parserName);
      return Object.assign({}, state, {
        vpnParsers: newVpnParsers,
        selectedVpnParser: newVpnParsers.length > 0 ? newVpnParsers[0].parser_name : ''
      });
    }
    case constActions.UPDATE_VPN_PARSERS_SUCCESS: {
      let newVpnParsersUpdate = state.vpnParsers.map((curVal, index) => {
        if (curVal.db_id == action.vpnParser.db_id) {
          return action.vpnParser;
        }
        return curVal;
      });

      return Object.assign({}, state, {
        vpnParsers: newVpnParsersUpdate,
        selectedVpnParser: action.vpnParser.parser_name
      });
    }
    case constActions.VALIDATE_VPN_PARSERS_SUCCESS:
      return Object.assign({}, state, {
        vpnValidationLineResult: action.results
      });

    //configuration - vpn parsers folder
    case constActions.GET_VPN_FOLDERS_SUCCESS:
      return Object.assign({}, state, {
        vpnParsersFolders: action.vpnParsersFolders,
        selectedVpnFolder: action.vpnParsersFolders.length > 0 ? action.vpnParsersFolders[0].directory_path : ''
      });
    case constActions.ADD_VPN_FOLDER_SUCCESS:
      return Object.assign({}, state, {
        vpnParsersFolders: [...state.vpnParsersFolders, action.vpnParserFolder],
        selectedVpnFolder: action.vpnParserFolder.directory_path
      });
    case constActions.DELETE_VPN_FOLDER_SUCCESS: {
      let newFoldersVpn = state.vpnParsersFolders.filter(curVal => curVal.directory_path != action.folderName);
      return Object.assign({}, state, {
        vpnParsersFolders: newFoldersVpn,
        selectedVpnFolder: newFoldersVpn.length > 0 ? newFoldersVpn[0].directory_path : ''
      });
    }
    case constActions.EDIT_VPN_FOLDER_SUCCESS:
      return Object.assign({}, state, {
        vpnParsersFolders: state.vpnParsersFolders.map((curVal, index) => {
          if (curVal.directory_path == action.vpnParserFolder.directory_path) {
            return action.vpnParserFolder;
          }
          return curVal;
        })
      });
    case constActions.ADD_AD_AND_CSV_PARSER_DATA_SUCCESS:
      return Object.assign({}, state, {
        userAdParams: [...action.AdType],
        userCsvParams: [...action.CsvType]
      });
    //configuration - elastic search server configuration
    case constActions.GET_ES_CONFIGURATION_SUCCESS:
      return Object.assign({}, state, {
        configurationES: action.configurationES
      });
    case constActions.UPDATE_ES_CONFIGURATION_FIELD_SUCCESS: {
      let configurationESNew = Object.assign({}, state.configurationES, action.property);
      return Object.assign({}, state, {
        configurationES: configurationESNew
      });
    }
    case constActions.GET_ES_STATUS:
      return Object.assign({}, state, {
        esStatus: action.status
      });
    /* ADVANCED*/

    case constActions.SET_EXTENSION_VALUE_ADVANCED:
      return Object.assign({}, state, {
        fileMonitoringExtensionValue: action.extensionValue
      });
    case constActions.SET_CUSTOM_EPS_CERT_ADVANCED: {
      let settingsConnectivity = Object.assign({}, state.advancedSettingsConnectivity, {
        CustomEpsCertSettings: action.results
      });
      return Object.assign({}, state, {
        advancedSettingsConnectivity: settingsConnectivity
      });
    }

    /*users */
    case constActions.UPDATE_USERS_SUCCESS:
      return Object.assign({}, state, {
        users: action.users
      });

    /*system info */
    case constActions.GET_SYSTEM_INFO_SUCCESS:
      return Object.assign({}, state, {
        systemInfo: action.systemInfo
      });

    /*alerts settings */
    case constActions.GET_ALERTS_SETTINGS_SUCCESS:
    case constActions.SAVE_ALERTS_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        alertsGeneralSettings: {
          ...action.alertsSettings.AlertsGeneralSettingsDTO,
          externalEmailsList: {
            EmailList: action.alertsSettings?.externalEmailsList?.EmailList.join(', '),
            IsSucceed: action.alertsSettings?.externalEmailsList?.IsSucceed
          }
        },
        alertMinimumSeverity: action.alertsSettings.AlertMinimumSeverity,
        alertsAutoHostScan: action.alertsSettings.AutoHostScanAlerts,
        alertPlaybookSettings: action.alertsSettings.PlaybookSettings
      });

    /*analysis settings */
    case constActions.GET_ANALYSIS_SUCCESS:
    case constActions.SAVE_ANALYSIS_SUCCESS:
      return Object.assign({}, state, {
        analysisSmartSimulation: action.analysisSettings.AnalysisSmartSimulationDTO
      });

    /*maps settings */
    case constActions.GET_SETTINGS_MAPS_DATA_SUCCESS:
      return Object.assign({}, state, {
        mapsData: [...action.mapsArr]
      });
    case constActions.SWITCH_TO_MAP_REGION:
      return Object.assign({}, state, {
        editRegionsMapId: action.mapId,
        editRegions: true
      });
    case constActions.SWITCH_TO_MAP_TABLE:
      return Object.assign({}, state, {
        editRegions: false
      });
    case constActions.SAVE_REGION_DATA:
      return Object.assign({}, state, {
        regionData: [...action.regionDataArr]
      });

    //////////////////////////////
    case constActions.GET_TV_MODE_TOKEN:
      return Object.assign({}, state, {
        tvModeToken: action.result
      });
    case constActions.UPDATE_TV_MODE_TOKEN:
      return Object.assign({}, state, {
        tvModeToken: action.tvModeToken
      });

    //////////////////////////////
    case constActions.SET_ACTIVE_DIRECTORY_GROUPS: {
      return Object.assign({}, state, {
        activeDirectoryGroups: action.groups
      });
    }
    case constActions.SET_ACTIVE_DIRECTORY_GROUPS_ENABLED: {
      return Object.assign({}, state, {
        activeDirectoryIdentitiesEnabled: action.groups
      });
    }
    case constActions.REMOVE_ACTIVE_DIRECTORY_GROUPS_ENABLED: {
      let index = state.activeDirectoryIdentitiesEnabled.findIndex(x => x.name === action.item.name);
      return Object.assign({}, state, {
        activeDirectoryIdentitiesEnabled: [
          ...state.activeDirectoryIdentitiesEnabled.slice(0, index),
          ...state.activeDirectoryIdentitiesEnabled.slice(index + 1)
        ]
      });
    }
    case constActions.ADD_ACTIVE_DIRECTORY_GROUPS_ENABLED: {
      return Object.assign({}, state, {
        activeDirectoryIdentitiesEnabled: [...state.activeDirectoryIdentitiesEnabled, Object.assign({}, action.group)]
      });
    }
    case constActions.GET_ACTIVE_DIRECTORY_CONNECTIONS: {
      return Object.assign({}, state, {
        connectionsAD: action.connections
      });
    }
    case constActions.ADD_ACTIVE_DIRECTORY_CONNECTIONS: {
      return Object.assign({}, state, {
        connectionsAD: [...state.connectionsAD, action.connection]
      });
    }
    case constActions.REMOVE_ACTIVE_DIRECTORY_CONNECTIONS: {
      let index = state.connectionsAD.findIndex(x => x.id === action.connection.id);
      return Object.assign({}, state, {
        connectionsAD: [...state.connectionsAD.slice(0, index), ...state.connectionsAD.slice(index + 1)]
      });
    }
    case constActions.GET_AWS_S3_SETTINGS: {
      return Object.assign({}, state, {
        s3Settings: action.s3Settings
      });
    }
    case constActions.GET_AWS_S3_BUCKET_SETTINGS: {
      return Object.assign({}, state, {
        s3BucketSettings: action.s3BucketSettings
      });
    }
    case constActions.ADD_AWS_S3_SETTINGS: {
      return Object.assign({}, state, {
        s3Settings: [...state.s3Settings, action.s3Settings]
      });
    }
    case constActions.ADD_AWS_S3_BUCKET_SETTINGS: {
      return Object.assign({}, state, {
        s3BucketSettings: [...state.s3BucketSettings, action.s3BucketSettings]
      });
    }
    case constActions.UPDATE_AWS_S3_SETTINGS: {
      return Object.assign({}, state, {
        s3Settings: state.s3Settings.map(o => (o.Id === action.s3Settings.Id ? action.s3Settings : o))
      });
    }
    case constActions.UPDATE_AWS_S3_BUCKET_SETTINGS: {
      return Object.assign({}, state, {
        s3BucketSettings: state.s3BucketSettings.map(o =>
          o.Id === action.s3BucketSettings.Id ? action.s3BucketSettings : o
        )
      });
    }
    case constActions.REMOVE_AWS_S3_SETTINGS: {
      let index = state.s3Settings.findIndex(x => x.Id === action.s3Settings.Id);
      let auditsS3SettingsToBucketSettingsIndex = state.auditsS3SettingsToBucketSettings.findIndex(
        x => x.S3SettingsId == action.s3Settings.Id
      );
      let alertsS3SettingsToBucketSettingsIndex = state.alertsS3SettingsToBucketSettings.findIndex(
        x => x.S3SettingsId == action.s3Settings.Id
      );
      return Object.assign({}, state, {
        s3Settings: [...state.s3Settings.slice(0, index), ...state.s3Settings.slice(index + 1)],
        auditsS3SettingsToBucketSettings: [
          ...state.auditsS3SettingsToBucketSettings.slice(0, auditsS3SettingsToBucketSettingsIndex),
          ...state.auditsS3SettingsToBucketSettings.slice(auditsS3SettingsToBucketSettingsIndex + 1)
        ],
        alertsS3SettingsToBucketSettings: [
          ...state.alertsS3SettingsToBucketSettings.slice(0, alertsS3SettingsToBucketSettingsIndex),
          ...state.alertsS3SettingsToBucketSettings.slice(alertsS3SettingsToBucketSettingsIndex + 1)
        ]
      });
    }
    case constActions.ADD_AUDITS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS: {
      return Object.assign({}, state, {
        auditsS3SettingsToBucketSettings: [...state.auditsS3SettingsToBucketSettings, action.s3SettingsToBucketSettings]
      });
    }
    case constActions.ADD_ALERTS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS: {
      return Object.assign({}, state, {
        alertsS3SettingsToBucketSettings: [...state.alertsS3SettingsToBucketSettings, action.s3SettingsToBucketSettings]
      });
    }
    case constActions.REMOVE_AWS_S3_BUCKET_SETTINGS: {
      let index = state.s3BucketSettings.findIndex(x => x.Id === action.s3BucketSettings.Id);
      let auditsS3SettingsToBucketSettingsIndex = state.auditsS3SettingsToBucketSettings.findIndex(
        x => x.S3BucketSettingsId == action.s3BucketSettings.Id
      );
      let alertsS3SettingsToBucketSettingsIndex = state.alertsS3SettingsToBucketSettings.findIndex(
        x => x.S3BucketSettingsId == action.s3BucketSettings.Id
      );
      return Object.assign({}, state, {
        s3BucketSettings: [...state.s3BucketSettings.slice(0, index), ...state.s3BucketSettings.slice(index + 1)],
        auditsS3SettingsToBucketSettings: [
          ...state.auditsS3SettingsToBucketSettings.slice(0, auditsS3SettingsToBucketSettingsIndex),
          ...state.auditsS3SettingsToBucketSettings.slice(auditsS3SettingsToBucketSettingsIndex + 1)
        ],
        alertsS3SettingsToBucketSettings: [
          ...state.alertsS3SettingsToBucketSettings.slice(0, alertsS3SettingsToBucketSettingsIndex),
          ...state.alertsS3SettingsToBucketSettings.slice(alertsS3SettingsToBucketSettingsIndex + 1)
        ]
      });
    }
    case constActions.GET_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS: {
      let auditsS3SettingsToBucketSettings = action.s3SettingsToBucketSettings.filter(
        x => x.S3DataType == eS3DataType.Audits.value
      );
      let alertsS3SettingsToBucketSettings = action.s3SettingsToBucketSettings.filter(
        x => x.S3DataType == eS3DataType.Alerts.value
      );
      return Object.assign({}, state, {
        auditsS3SettingsToBucketSettings: auditsS3SettingsToBucketSettings,
        alertsS3SettingsToBucketSettings: alertsS3SettingsToBucketSettings
      });
    }
    case constActions.REMOVE_AUDITS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS: {
      let index = state.auditsS3SettingsToBucketSettings.findIndex(x => x.Id === action.s3SettingsToBucketSettings.Id);
      return Object.assign({}, state, {
        auditsS3SettingsToBucketSettings: [
          ...state.auditsS3SettingsToBucketSettings.slice(0, index),
          ...state.auditsS3SettingsToBucketSettings.slice(index + 1)
        ]
      });
    }
    case constActions.REMOVE_ALERTS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS: {
      let index = state.alertsS3SettingsToBucketSettings.findIndex(x => x.Id === action.s3SettingsToBucketSettings.Id);
      return Object.assign({}, state, {
        alertsS3SettingsToBucketSettings: [
          ...state.alertsS3SettingsToBucketSettings.slice(0, index),
          ...state.alertsS3SettingsToBucketSettings.slice(index + 1)
        ]
      });
    }
    case constActions.GET_GLOBAL_SETTINGS_SUCCESS: {
      return Object.assign({}, state, {
        globalSettings: action.globalSettings
      });
    }
    case constActions.GET_PROTECTION_PROFILES_SUCCESS: {
      return Object.assign({}, state, {
        protectionProfiles: [...action.profiles]
      });
    }
    case constActions.SET_AUTHNETICATION_MODE: {
      return Object.assign({}, state, {
        authenticationMode: action.mode
      });
    }
    case constActions.SET_ACTIVE_DIRECTORY_CONNECTIONS: {
      return Object.assign({}, state, {
        connectionsAD: state.connectionsAD.map(o => (o.id === action.connection.id ? action.connection : o))
      });
    }
    /* vulnerable management */
    case constActions.VULNERABLE_MANAGEMENT_TAB_SELECT_SUCCESS: {
      return Object.assign({}, state, {
        selectedVulnerabilityTabId: action.selectedVulnerabilityTabId
      });
    }
    case constActions.WINDOWS_CRITICAL_PATCHES_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        windowsCriticalPatches: action.windowsCriticalPatches
      });
    }
    case constActions.RISKY_APPLICATION_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        riskyApplications: action.riskyApplications
      });
    }
    case constActions.RUNNING_APPS_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        runningApplications: action.runningApplications
      });
    }
    case constActions.OUTDATE_APPLICATION_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        outdatedApplications: action.outdatedApplications
      });
    }

    /* UBA Events */
    case constActions.SET_UBA_EVENTS: {
      return Object.assign({}, state, {
        ubaEvents: action.results
      });
    }
    case constActions.DELETE_UBA_EVENT: {
      let index = state.ubaEvents.findIndex(x => x.id === action.results);
      return Object.assign({}, state, {
        ubaEvents: [...state.ubaEvents.slice(0, index), ...state.ubaEvents.slice(index + 1)]
      });
    }
    case constActions.UPDATE_UBA_EVENT: {
      let ubaEventsUpdated = state.ubaEvents.map((item, index) => {
        if (item.id == action.results.id) {
          let objUpdated = Object.assign({}, item);
          objUpdated.isDisabled = action.results.isDisabled;
          return objUpdated;
        }
        return item;
      });
      return Object.assign({}, state, {
        ubaEvents: ubaEventsUpdated
      });
    }
    case constActions.CREATE_UBA_EVENT: {
      return Object.assign({}, state, {
        ubaEvents: [...state.ubaEvents, action.result]
      });
    }
    /*THREAT HUNTING */
    case constActions.SET_THREAT_HUNTING_DATA: {
      return Object.assign({}, state, {
        threatHuntingSearchCriteria: [...action.threatHuntingArr]
      });
    }
    case constActions.SET_THREAT_HUNTING_META_DATA: {
      return Object.assign({}, state, {
        threatHuntingSearchMeta: Object.assign({}, action.metaObj)
      });
    }
    //DECOY FILES
    case constActions.SAVE_DECOY_DATA:
      return Object.assign({}, state, {
        decoyFilesArray: action.DecoyFileDTO
      });
    case constActions.SAVE_DECOY_GROUPS_AND_FOLDERS:
      return Object.assign({}, state, {
        decoyGroupsAndFolders: [...state.decoyGroupsAndFolders, action.DecoyToGroupByFileID]
      });
    case constActions.UPDATE_DECOY_GROUPS_AND_FOLDERS:
      return Object.assign({}, state, {
        decoyGroupsAndFolders: [...action.DecoyToGroupByFileIDArr]
      });
    case constActions.SAVE_GROUP_WITH_DECOY_ENABLED:
      return Object.assign({}, state, {
        GroupWithDecoyEnabled: [...action.GroupWithDecoyEnabled]
      });

    // global mode
    case constActions.ADD_SITE_TO_USER: {
      let usersByLoggedInUserAdded = state.usersByLoggedInUser.map(function (item, index) {
        if (item.id == action.data.user.id) {
          let newUser = Object.assign({}, item, {
            slaves: [...item.slaves, action.data.site]
          });
          return newUser;
        }
        return item;
      });
      return Object.assign({}, state, {
        usersByLoggedInUser: usersByLoggedInUserAdded
      });
    }
    case constActions.TOGGLE_ALL_SITES_INTERACTION_START: {
      return Object.assign({}, state, {
        isGridBlocked: true
      });
    }
    case constActions.ADD_ALL_SITES_TO_USER_SUCCESS: {
      return Object.assign({}, state, {
        isGridBlocked: false
      });
    }
    case constActions.REMOVE_SITE_TO_USER: {
      let usersByLoggedInUserRemovedSite = state.usersByLoggedInUser.map(function (item, index) {
        if (item.id == action.data.user.id) {
          let slavesAfterRemove = item.slaves.filter(x => x.ClientId != action.data.site.ClientId);
          let newUser = Object.assign({}, item, {
            slaves: slavesAfterRemove
          });
          return newUser;
        }
        return item;
      });

      return Object.assign({}, state, {
        usersByLoggedInUser: usersByLoggedInUserRemovedSite
      });
    }
    case constActions.REMOVE_ALL_SITES_FROM_USER_SUCCESS: {
      return Object.assign({}, state, {
        isGridBlocked: false
      });
    }
    case constActions.TOGGLE_ALL_SITES_INTERACTION_ERROR: {
      return Object.assign({}, state, {
        isGridBlocked: false,
        siteTogglingError: action.error
      });
    }
    case constActions.DISMISS_SITE_TOGGLING_ERROR: {
      return Object.assign({}, state, {
        isGridBlocked: false,
        siteTogglingError: ''
      });
    }
    case constActions.GET_ALL_SITES: {
      return Object.assign({}, state, {
        sites: action.sites
      });
    }
    case constActions.ADD_SITE: {
      return Object.assign({}, state, {
        allSlavesSites: [...state.allSlavesSites, Object.assign({}, action.site)]
      });
    }
    case constActions.REMOVE_SITE: {
      let index = state.allSlavesSites.findIndex(x => x.ClientId == action.ClientId);
      return Object.assign({}, state, {
        allSlavesSites: [...state.allSlavesSites.slice(0, index), ...state.allSlavesSites.slice(index + 1)]
      });
    }
    case constActions.GET_ALL_SLAVES_SITES: {
      return Object.assign({}, state, {
        allSlavesSites: action.sites
      });
    }
    case constActions.GET_USERS_BY_LOGGED_IN_USER_PERMISSIONS: {
      return Object.assign({}, state, {
        usersByLoggedInUser: action.usersByLoggedInUser
      });
    }

    // Windows Events
    case constActions.GET_WINDOWS_EVENTS_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        windowsEventsProfiles: [...action.profiles]
      });
    case constActions.ADD_WINDOWS_EVENTS_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        windowsEventsProfiles: [...state.windowsEventsProfiles, action.profile]
      });
    case constActions.UPDATE_WINDOWS_EVENTS_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        windowsEventsProfiles: state.windowsEventsProfiles.map(r => {
          if (r.id === action.profile.id) {
            return action.profile;
          } else {
            return r;
          }
        })
      });
    case constActions.REMOVE_WINDOWS_EVENTS_PROFILE_SUCCESS: {
      let updatedProfileId = state.groupInformation.WEProfileId;
      if (updatedProfileId == action.profileId) {
        updatedProfileId = state.windowsEventsProfiles.find(r => r.isDefault).id;
      }

      return Object.assign({}, state, {
        windowsEventsProfiles: state.windowsEventsProfiles.filter(r => r.id !== action.profileId),
        groupInformation: Object.assign({}, state.groupInformation, {
          WEProfileId: updatedProfileId
        })
      });
    }

    // Storage Devices
    case constActions.ADD_EXCEPTION_TO_STORAGE_DEVICE_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        quickStorageDeviceProfiles: [...state.quickStorageDeviceProfiles, action.profiles]
      });
    case constActions.GET_STORAGE_DEVICES_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        storageDevicesProfiles: [...action.profiles]
      });
    case constActions.GET_STORAGE_DEVICES_PROFILES_WITH_UNAUTHORIZED_CLASSIFICATION_SUCCESS:
      return Object.assign({}, state, {
        quickStorageDeviceProfiles: [...action.profiles]
      });
    case constActions.GET_STORAGE_DEVICE_ID_FROM_ALERT_SUCCESS:
      return Object.assign({}, state, {
        quickStorageDeviceProfile: action.profile
      });
    case constActions.ADD_STORAGE_DEVICES_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        storageDevicesProfiles: [...state.storageDevicesProfiles, action.profile]
      });
    case constActions.UPDATE_STORAGE_DEVICES_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        storageDevicesProfiles: state.storageDevicesProfiles.map(r => {
          if (r.id === action.profile.id) {
            return action.profile;
          } else {
            return r;
          }
        })
      });
    case constActions.STORAGE_DEVICES_PROFILE_ERROR:
      return Object.assign({}, state, {
        storageDeviceError: action.error
      });
    case constActions.REMOVE_STORAGE_DEVICES_PROFILE_SUCCESS: {
      let updatedSDProfileId = state.groupInformation.SDProfileId;
      if (updatedSDProfileId == action.profileId) {
        updatedSDProfileId = state.storageDevicesProfiles.find(r => r.isDefault).id;
      }

      return Object.assign({}, state, {
        storageDevicesProfiles: state.storageDevicesProfiles.filter(r => r.id !== action.profileId),
        groupInformation: Object.assign({}, state.groupInformation, {
          SDProfileId: updatedSDProfileId
        })
      });
    }
    case constActions.GET_STORAGE_DEVICES_VENDORS_AND_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        storageDevicesVendorsAndProducts: [...action.storageDevicesVendorsAndProducts]
      });

    //FILE MONITOR
    case constActions.GET_FILE_MONITOR_RULES_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        fileMonitorProfiles: [...action.profiles]
      });
    case constActions.ADD_FILE_MONITOR_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        fileMonitorProfiles: [...state.fileMonitorProfiles, action.profile]
      });
    case constActions.UPDATE_FILE_MONITOR_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        fileMonitorProfiles: state.fileMonitorProfiles.map(r => {
          if (r.id === action.profile.id) {
            return action.profile;
          } else {
            return r;
          }
        })
      });
    case constActions.REMOVE_FILE_MONITOR_PROFILE_SUCCESS: {
      let updatedProfileIdFm = state.groupInformation.FileMonitorProfileID;
      if (updatedProfileIdFm == action.profileId) {
        updatedProfileIdFm = state.fileMonitorProfiles.find(r => r.isDefault).id;
      }

      return Object.assign({}, state, {
        fileMonitorProfiles: state.fileMonitorProfiles.filter(r => r.id !== action.profileId),
        groupInformation: Object.assign({}, state.groupInformation, {
          FileMonitorProfileID: updatedProfileIdFm
        })
      });
    }
    //Whitelisting
    /* get profiles */
    case constActions.GET_WHITELISTING_RULES_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        whitelistingRulesProfiles: [...action.profiles],
        whitelistingRulesError: ''
      });
    case constActions.GET_WHITELISTING_EXCLUSION_RULES_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        whitelistingExclusionRulesProfiles: [...action.profiles],
        whitelistingExclusionRulesError: ''
      });
    /* edit profile */
    case constActions.GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_SUCCESS:
      return Object.assign({}, state, {
        // whitelistingRulesEditedProfile: action.profile,
        whitelistingRulesViewState: eProfileView.EditProfile,
        whitelistingRulesError: ''
      });
    case constActions.GET_EXCLUSION_RULES_PROFILE_FOR_EDIT_SUCCESS:
      return Object.assign({}, state, {
        // whitelistingExclusionRulesEditedProfile: action.profile,
        whitelistingRulesViewState: eProfileView.EditProfile,
        whitelistingRulesError: ''
      });
    case constActions.GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_FAILURE:
      return Object.assign({}, state, {
        whitelistingRulesError: action.error
      });
    /* groups */
    case constActions.GET_WHITELISTING_RULES_SCAN_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        whitelistingRulesScanGroups: [...action.scanGroups]
      });
    /* hosts */
    case constActions.GET_WHITELISTING_RULES_HOSTS_SUCCESS:
      return Object.assign({}, state, {
        whitelistingRulesHostOptions: [...action.hosts]
      });
    case constActions.SET_WHITELISTING_DATA:
      return Object.assign({}, state, {
        whitelistingCriteria: [...action.whitelistArr]
      });
    case constActions.SET_WHITELISTING_RULES_ALERTS:
      return Object.assign({}, state, {
        whiteListRulesAlerts: [...action.rulesAlertsArr]
      });
    case constActions.SET_WHITELISTING_RULES_TYPES:
      return Object.assign({}, state, {
        whiteListRulesType: [...action.rulesTypesArr]
      });
    case constActions.UPDATE_EXCLUDED_HOST_NAMES_LIST_SUCCESS:
      return Object.assign({}, state, {
        excludedHostNames: action.results
      });
    //Quick Whitelisting
    case constActions.GET_QUICK_WHITELISTING_PROFILE_REQUEST:
      return Object.assign({}, state, {
        quickWhiteListingProfile: null,
        quickWhiteListError: null
      });
    case constActions.GET_QUICK_WHITELISTING_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        quickWhiteListingProfile: action.profile,
        quickWhiteListError: null
      });
    case constActions.GET_QUICK_WHITELISTING_PROFILE_ERROR:
      return Object.assign({}, state, {
        quickWhiteListingProfile: null,
        quickWhiteListError: action.error
      });

    case constActions.ADD_QUICK_WHITELISTING_RULES_PROFILE_REQUEST:
      return Object.assign({}, state, {
        quickWhiteListError: null
      });
    // case constActions.ADD_QUICK_WHITELISTING_RULES_PROFILE_SUCCESS:
    //     return Object.assign({}, state, {
    //         quickWhiteListingProfile: null,
    //         quickWhiteListError: action.error
    //     });
    case constActions.ADD_QUICK_WHITELISTING_RULES_PROFILE_ERROR:
      return Object.assign({}, state, {
        quickWhiteListError: action.error
      });

    /*REMEDIATION*/
    case constActions.SET_SELECTED_REMEDIATION_TAB:
      return Object.assign({}, state, {
        selectedRemediationTabId: action.selectedRemediationTabId
      });
    case constActions.SET_CUSTOM_REMEDIATION_IS_LOADING_DATA:
      return Object.assign({}, state, {
        remediationIsLoading: action.isLoading
      });
    //CUSTOM REMEDIATION
    case constActions.SET_CUSTOM_REMEDIATION_VIEW_STATE:
      return Object.assign({}, state, {
        customRemediationViewState: action.viewState
      });
    case constActions.SET_CURRENT_EDITED_CUSTOM_REMEDIATION:
      return Object.assign({}, state, {
        currentEditedCustomRemediation: action.customRemediation
      });
    case constActions.UPDATE_CUSTOM_REMEDIATIONS:
      return Object.assign({}, state, {
        customRemediations: action.customRemediations
      });
    case constActions.GET_ACTIVE_VAULT_OBJECTS:
      return Object.assign({}, state, {
        activeVaultObjects: action.activeVaultObjects
      });
    //PLAYBOOKS
    case constActions.SET_PLAYBOOKS_VIEW_STATE:
      return Object.assign({}, state, {
        playbookViewState: action.viewState
      });
    case constActions.SET_PLAY_BOOK_FORM_DATA:
      return Object.assign({}, state, {
        playBookForm: action.playBook
      });
    case constActions.UPDATE_PLAYBOOKS:
      return Object.assign({}, state, {
        playBooks: action.playBooks
      });
    //CUSTOM REMEDITAION EXECUTION SERVERS
    case constActions.UPDATE_CUSTOM_REMEDIATION_EXECUTION_SERVERS:
      return Object.assign({}, state, {
        customRemediationExecutionServers: action.executionServers
      });
    case constActions.UPDATE_CUSTOM_REMEDIATION_HAS_AVAILABLE_EXECUTION_SERVERS:
      return Object.assign({}, state, {
        customRemediationHasAvailableExecutionServers: action.hasAvailableExecutionServers
      });
    // DECEPTION USER
    case constActions.GET_ALL_DECEPTION_USER_CONFIGURATION:
      return Object.assign({}, state, {
        deceptionUserConfiguration: action.results
      });
    case constActions.GET_DECEPTION_USERS_TO_DENY:
      return Object.assign({}, state, {
        deceptionUsersToDeny: action.results
      });
    // DECEPTION NETWORK
    case constActions.SET_DECEPTION_NETWORK_MAX_DECOY_HOSTS:
      return Object.assign({}, state, {
        deceptionNetMaxDecoyHosts: action.deceptionNetMaxDecoyHosts
      });
    case constActions.SET_DECEPTION_NETWORK_SELECTED_GROUP_ID:
      return Object.assign({}, state, {
        deceptionNetSelectedScanGroupId: action.deceptionNetSelectedScanGroupId
      });
    case constActions.SET_DECEPTION_NETWORK_CONFIGURATION:
      return Object.assign({}, state, {
        deceptionNetConfigurationForGroup: action.deceptionNetConfigurationForGroup
      });
    case constActions.SET_DECEPTION_NETWORK_MULTI_SELECT:
      return Object.assign({}, state, {
        deceptionNetIsMultiSelectChecked: action.deceptionNetIsMultiSelectChecked
      });
    case constActions.SET_DECEPTION_NETWORK_OS_VERSIONS:
      return Object.assign({}, state, {
        deceptionNetOsVersions: action.deceptionNetOsVersions
      });

    //CISO KIT
    case constActions.GET_ALL_CISO_KIT_CONNECTIONS: {
      return Object.assign({}, state, {
        enableIPhoneConnection: action.iPhoneResults,
        enableIPadConnection: action.iPadResults
      });
    }
    case constActions.ADD_CISO_KIT_CONNECTION: {
      return Object.assign({}, state, {
        cisoKitConnections: [...state.cisoKitConnections, action.result]
      });
    }
    case constActions.IS_CISO_KIT_ENABLED: {
      return Object.assign({}, state, {
        isCisoKitEnabled: action.result
      });
    }
    case constActions.UPDATE_USER_ROLE_SUCESS:
      return Object.assign({}, state, {
        users: state.users.map(r => {
          if (r.userId == action.user.userId) {
            return action.user;
          } else {
            return r;
          }
        })
      });
    case constActions.UPDATE_IDENTITY_ROLE_SUCESS:
      return Object.assign({}, state, {
        activeDirectoryIdentitiesEnabled: state.activeDirectoryIdentitiesEnabled.map(r => {
          if (r.id == action.identity.id) {
            return action.identity;
          } else {
            return r;
          }
        })
      });
    //--------global---------
    case constActions.GET_USER_HAS_PERMISSION_ALL_MSSP_SITES:
      return { ...state, manageProfilesMode: action.result };
    case constActions.GET_TAGS:
      return { ...state, userTags: action.result };
    case constActions.GET_CLIENT_TYPES:
      return { ...state, userClientTypes: action.result };
    case constActions.SET_GLOBAL_VERSION: {
      return Object.assign({}, state, {
        globalServerVersion: action.result
      });
    }
    case constActions.UPDATE_EMAIL_RECIPIENTS_MULTIPLE_EDIT_FORM:
      return Object.assign({}, state, {
        multipleEditEmailRecipientsValue: action.multiEditConfig
      });
    case constActions.UPDATE_SITES_EMAIL_RECIPIENTS: {
      let sortedList = action.slaveSitesConfig;
      if (action.slaveSitesConfig != undefined && action.slaveSitesConfig.length > 0)
        sortedList = action.slaveSitesConfig.sort((a, b) => a.SlaveSiteName.localeCompare(b.SlaveSiteName));
      return Object.assign({}, state, {
        SitesEmailRecipients: sortedList
      });
    }
    case constActions.SET_SITE_BILLING: {
      return Object.assign({}, state, {
        siteBillingSettings: action.result
      });
    }
    //SIEM
    case constActions.UPDATE_SLAVE_SITE_SETTINGS:
      return Object.assign({}, state, {
        siemSlaveSitesSettings: [...action.newSlaveSitesSettings]
      });
    case constActions.UPDATE_SIEM_ERROR_FIELD:
      return Object.assign({}, state, {
        siemErrors: Object.assign({}, state.siemErrors, {
          [action.fieldName]: action.errorText
        })
      });
    case constActions.UPDATE_SIEM_STATUSES:
      return Object.assign({}, state, {
        siemSlaveSitesStatuses: [...action.siemSlaveSitesStatuses]
      });
    case constActions.UPDATE_SIEM_ALL_SETTINGS:
      return Object.assign({}, state, {
        siemAllSettings: Object.assign({}, action.siemAllSettingsState)
      });
    case constActions.UPDATE_SIEM_GLOBAL_SETTINGS:
      return Object.assign({}, state, {
        globalManagmentSiemSettings: Object.assign({}, action.globalManagmentSiemSettings)
      });
    case constActions.INITIALIZE_SITES_CONFIG_DATA:
      return Object.assign({}, state, {
        slaveSitesConfig: [],
        multipleEditConfigValue: {}
      });
    case constActions.UPDATE_SITES_CONFIG: {
      let sortedList = action.slaveSitesConfig;
      if (action.slaveSitesConfig != undefined && action.slaveSitesConfig.length > 0)
        sortedList = action.slaveSitesConfig.sort((a, b) => a.SlaveSiteName.localeCompare(b.SlaveSiteName));
      return Object.assign({}, state, {
        slaveSitesConfig: sortedList
      });
    }
    case constActions.UPDATE_CONFIG_MULTIPLE_EDIT_FORM:
      return Object.assign({}, state, {
        multipleEditConfigValue: action.multiEditConfig
      });
    case constActions.INITIALIZE_SCAN_GROUPS_TAB_DATA:
      return Object.assign({}, state, {
        scanGroupFeatures: [],
        selectedScanGroupFeatureId: 0,
        slaveSitesScanGroups: [],
        slaveSitesScanGroupsStatus: [],
        multipleEditScanGroup: {}
      });
    case constActions.UPDATE_SCAN_GROUPS_FEATURES:
      return Object.assign({}, state, {
        scanGroupFeatures: action.scanGroupFeatures
      });
    case constActions.UPDATE_SITES_SCAN_GROUPS:
      return Object.assign({}, state, {
        slaveSitesScanGroups: action.slaveSitesScanGroups
      });
    case constActions.UPDATE_SCAN_GROUPS_SELECTED_FEATURE:
      return Object.assign({}, state, {
        selectedScanGroupFeatureId: action.featureId
      });
    case constActions.UPDATE_SCAN_GROUPS_SLAVE_SITES_STATUS:
      return Object.assign({}, state, {
        slaveSitesScanGroupsStatus: action.slaveSitesScanGroupsStatus
      });
    case constActions.INITIALIZE_SCAN_GROUPS_FEATURES_FORM_STATUS:
      return Object.assign({}, state, {
        slaveSitesScanGroupsStatus: [],
        multipleEditScanGroup: {}
      });
    case constActions.UPDATE_SCAN_GROUPS_MULTIPLE_EDIT_FORM:
      return Object.assign({}, state, {
        multipleEditScanGroup: action.multipleEditScanGroup
      });

    case constActions.GET_ALL_SLAVES_SYSTEM_STATUS: {
      return Object.assign({}, state, {
        allSlavesSystemStatus: action.allSlavesSystemStatus
      });
    }
    case constActions.SHOULD_SHOW_EDIT_DETAILS: {
      return Object.assign({}, state, {
        shouldShowEdit: action.shouldShow
      });
    }
    case constActions.GET_ADVANCED_REPORTS_SCHEDULES_LIST:
      return Object.assign({}, state, {
        advancedReportsSchedules: action.results.schedules || []
      });

    case constActions.GET_SITES_WHITELISTING_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        sitesWhitelistingRulesProfiles: [...action.profiles],
        siteWhitelistingRulesError: action.err
      });
    case constActions.GET_SITES_EXCLUSION_PROFILES_SUCCESS:
      return Object.assign({}, state, {
        sitesExclusionRulesProfiles: [...action.profiles],
        siteExclusionRulesError: action.err
      });
    default:
      return state;
  }
}
